import { toLocaleFromString } from '@peloton/internationalize';
import { getLocale as getLocaleFromTime, formatDate } from '@peloton/time';
import { DateFormat, getFormatStringsForLocale, getInfoForLocale, TimeFormat } from './dateTimeUtils';
import { SupportedFormat } from './SupportedFormat';

var getTimeFormatForLocale = function getTimeFormatForLocale(locale) {
  return getInfoForLocale(locale).timeFormat;
};

var getDateFormatForLocale = function getDateFormatForLocale(locale) {
  return getInfoForLocale(locale).dateFormat;
};

var formatLocalizedDate = function formatLocalizedDate(date, format, getLocale) {
  return formatDate(date, getFormatStringsForLocale(toLocaleFromString(getLocaleOrDefault(getLocale)()))[format]);
};

var getLocaleOrDefault = function getLocaleOrDefault(getLocale) {
  return typeof getLocale === 'function' ? getLocale : getLocaleFromTime;
};

export var isTwelveHourTimeFormat = function isTwelveHourTimeFormat(getLocale) {
  return getTimeFormatForLocale(toLocaleFromString(getLocaleOrDefault(getLocale)())) === TimeFormat.TwelveHour;
};
export var isTwentyFourHourTimeFormat = function isTwentyFourHourTimeFormat(getLocale) {
  return getTimeFormatForLocale(toLocaleFromString(getLocaleOrDefault(getLocale)())) === TimeFormat.TwentyFourHour;
};
export var isMonthDayYearFormat = function isMonthDayYearFormat(getLocale) {
  return getDateFormatForLocale(toLocaleFromString(getLocaleOrDefault(getLocale)())) === DateFormat.MonthDayYear;
};
export var isDayMonthYearFormat = function isDayMonthYearFormat(getLocale) {
  return getDateFormatForLocale(toLocaleFromString(getLocaleOrDefault(getLocale)())) === DateFormat.DayMonthYear;
};
export var toLocalizedAbbreviatedLong = function toLocalizedAbbreviatedLong(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.AbbreviatedLong, getLocale);
};
export var toLocalizedAbrevLongWithoutDay = function toLocalizedAbrevLongWithoutDay(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.AbrevLongWithoutDay, getLocale);
};
export var toLocalizedSlashedDate = function toLocalizedSlashedDate(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.SlashedDate, getLocale);
};
export var toLocalizedSlashedDateLongYear = function toLocalizedSlashedDateLongYear(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.SlashedDateLongYear, getLocale);
};
export var toLocalizedTwoDigitMonthSlashedDate = function toLocalizedTwoDigitMonthSlashedDate(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.TwoDigitMonthSlashedDate, getLocale);
};
export var toLocalizedDayNameMonthDate = function toLocalizedDayNameMonthDate(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.DayNameMonthDate, getLocale);
};
export var toLocalizedDayNameShortMonthDate = function toLocalizedDayNameShortMonthDate(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.DayNameShortMonthDate, getLocale);
};
export var toLocalizedDayNameShort = function toLocalizedDayNameShort(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.DayNameShort, getLocale);
};
export var toLocalizedMonthNameShortDate = function toLocalizedMonthNameShortDate(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.MonthNameShortDate, getLocale);
};
export var toLocalizedShortMonthDate = function toLocalizedShortMonthDate(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.ShortMonthDate, getLocale);
};
export var toLocalizedDayFirstLetter = function toLocalizedDayFirstLetter(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.DayNameShort, getLocale)[0];
};
export var toLocalizedDayOfMonth = function toLocalizedDayOfMonth(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.DayOfMonth, getLocale);
};
export var toLocalizedMonthYear = function toLocalizedMonthYear(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.MonthYear, getLocale);
};
export var toLocalizedDayNameLongMonthSlashDay = function toLocalizedDayNameLongMonthSlashDay(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.DayNameLongMonthSlashDay, getLocale);
};
export var toLocalizedMonthNameYear = function toLocalizedMonthNameYear(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.MonthNameYear, getLocale);
};
export var toLocalizedTime = function toLocalizedTime(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.Time, getLocale);
};
export var toMonthNameShort = function toMonthNameShort(date, getLocale) {
  return formatLocalizedDate(date, SupportedFormat.MonthNameShort, getLocale);
};